import React, { Component } from 'react';
import './App.scss';
import { FormControl, InputGroup, Button, DropdownButton, Dropdown } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import service from "./service/api"
import Holder from "./Holder"
import Chart from "./Chart"

import * as XLSX from 'xlsx'; // Ensure SheetJS is imported

const btn_gp = [
  { key : 'score' , display : "Strength" },
  { key : 'vcp' , display : "VCP" },
  { key : 'marketcap' , display : "Market Cap" },
]

const btn2 = [
  { key : 'near_200d_high' , display : "Near 200D high" },
  { key : 'near_200d_low' , display : "Near 200D low" },
  { key : 'near_150d_high' , display : "Near 150D high" },
  { key : 'near_150d_low' , display : "Near 150D low" },
  { key : 'near_100d_high' , display : "Near 100D high" },
  { key : 'near_100d_low' , display : "Near 100D low" },
  { key : 'near_50d_high' , display : "Near 50D high" },
  { key : 'near_50d_low' , display : "Near 50D low" },

]

class App extends Component {

  constructor(props) {
    super(props)
    this.state = {
      original : [],
      rank : [],
      data : [],
      category : [],
      industry : [],
      subindustry : [],
      selectedCategory : {},
      displayData : [],
      currentDate :  "",
      date : "",
      selectedSymbol : null,
      chartData : [],
      searchSymbol : "",
      marketcap : "0",
      score : "0",
      vcp : "0",
      marketcap_type : false,
      score_type : false,
      vcp_type : false,
      near_200d_high : null,
      near_200d_low : null,
      near_150d_high : null,
      near_150d_low : null,
      near_100d_high : null,
      near_100d_low : null,
      near_50d_high : null,
      near_50d_low : null,
      searchTypes : {},
      displayRank : [],
    }
    this.getTableApi = this.getTableApi.bind(this)
    this.getIndexRank = this.getIndexRank.bind(this)
    this.display = this.display.bind(this)
    this.updateValue=this.updateValue.bind(this)
    this.getIndex = this.getIndex.bind(this)
    this.searchSym = this.searchSym.bind(this)
    this.refresh = this.refresh.bind(this)
    this.save = this.save.bind(this)
  }

  componentDidMount() {
    var sym = null
    if( window.location.search ) {
      sym = window.location.search.replace("?symbol=", "") + ".HK"
    }
    this.getIndexRank(null, sym)
  }
  
  getTableApi(date, symbol) {
    var obj ={}
    if(date) {
      obj['date'] =date
    }
    service.getTableApi(obj).then( 
      (res) => {
          this.setState({
            data : res,
            original : res,
          })
          var _this = this
          setTimeout( () => {
            
            if(symbol) {
              _this.searchSym( symbol, true )
            } else {
              _this.display( this.state.selectedCategory )
              _this.getIndex()
            }
          }, 500 )
          
      }
     )
  }

  getIndexRank(date, symbol){
    var obj = {}
    if(date) {
      obj['date']=date
    }
    service.getIndexRank(obj).then( 
      (res) => {
        res = res.sort( (a, b) => { // non-anonymous as you ordered...
          return b.ema < a.ema ?  -1 // if b should come earlier, push a to end
               : b.ema > a.ema ? 1 // if b should come later, push a to begin
               : 0
        })
        this.setState({
          rank : res,
          displayRank : res,
          selectedCategory : res[0],
          currentDate : res[0].date,
          date : res[0].date,
        })
        this.getTableApi(date, symbol)
      }
    )
  }

  search() {
    var searchTypes = this.state.searchTypes
    try {
      var data = JSON.parse( JSON.stringify( this.state.original ) )
      for (var i in searchTypes) {
        data = data.filter( (item) =>{
          if( 
            (i === "near_200d_high") || (i === "near_200d_low") || 
            (i === "near_150d_high") || (i === "near_150d_low") || 
            (i === "near_100d_high") || (i === "near_100d_low") || 
            (i === "near_50d_high") || (i === "near_50d_low") 
          ){
          //if ( (i === "near_high") || (i === "near_low") ) {
            return item[  i  ] === searchTypes[i]; 
          } else {
            if( this.state[ i+"_type" ] ) {
              return item[  i  ] < searchTypes[i]; 
            } else {
              return item[  i  ] >= searchTypes[i];         
            }
          }
        })
      }
      var cat =data.map( (value) => value.category).filter( (value, index, _arr) => _arr.indexOf(value) == index);
      var rank = JSON.parse( JSON.stringify(  this.state.rank  ) )
      cat.push("HSI")
      rank = rank.map( (v,k) => {
        return (cat.indexOf(v.category) > -1)?v:null
      }).filter( (value, index) => {
        return value !== null
      } )
      this.setState({
        //searchTypes : searchTypes,
        data : data,
        displayRank : rank
      })
      var _this = this
      setTimeout( (e)=>{
        _this.display( _this.state.selectedCategory )
      }, 500 )
    }
    catch(e) {

    }
  }

  display(obj) {
    var v = JSON.parse( JSON.stringify(obj) )
    var arr = []
    var data = JSON.parse( JSON.stringify(this.state.data ) )
    data = data.filter( (item) =>{
      return item.category === obj.category;         
    })

    var _d = data.filter( (item) =>{
      return item.symbol === "1146.HK";         
    })
    console.log(_d)

    var ind =data.map( (value) => value.iname).filter( (value, index, _arr) => _arr.indexOf(value) == index);
    for (var i in ind) {
      var obj = {}
      obj['key'] = ind[i]
      obj['value'] = []
      var d = data.filter( (item) =>{
        return item.iname === ind[i];         
      })
      var sind =d.map( (value) => value.sname).filter( (value, index, _arr) => _arr.indexOf(value) == index);
      var i_score = 0, i_mc = 0
      for (var j in sind) {
        var o = {}
        o['key'] = sind[j]
        var ds = data.filter( (item) =>{
          return item.sname === sind[j];         
        })   
        var sums = ds.map( (v)=>v.marketcap ).reduce( (s,v) => s+v  )   
        ds.map( (v,k)=>{ v.ws = v.marketcap*v.score/sums } )
        var s_score = ds.map( (v)=>v.ws ).reduce( (s,v) => s+v  ) 
        o['s_score'] = s_score
        i_mc += sums
        i_score += sums*s_score
        o['value'] = ds
        obj['value'].push( o )
      }
      obj['value'] = obj['value'].sort( (a, b) => { // non-anonymous as you ordered...
        return b.s_score < a.s_score ?  -1 // if b should come earlier, push a to end
             : b.s_score > a.s_score ? 1 // if b should come later, push a to begin
             : 0
      })

      obj['i_score'] = i_score/i_mc
      arr.push( obj )
    }
    arr = arr.sort( (a, b) => { // non-anonymous as you ordered...
      return b.i_score < a.i_score ?  -1 // if b should come earlier, push a to end
           : b.i_score > a.i_score ? 1 // if b should come later, push a to begin
           : 0
    })

    if( this.state.selectedSymbol ) {
      this.getIndex()
    }

  
    this.setState({
      selectedCategory : v,
      displayData : arr,
      selectedSymbol : null,
    })
  
    
  }

  updateValue(obj) {
    
    if( "selectedSymbol" in obj ) {
      //console.log(  obj )
      if( obj["selectedSymbol"] ) {
        this.setState( {
          chartData : []
        })
        service.getSymbolApi( { "symbols" : [obj["selectedSymbol"]] } ).then(
          (res) => {         
            var score = []
            var vcp = []

            res = res.map( (v,k)=>{
              var obj = {}
              obj['date'] = v.date
              obj['index'] = v.score
              obj['x'] = v.date
              obj['y'] = v.score
              score.push(  obj  )
              var _obj = {}
              _obj['date'] = v.date
              _obj['index'] = v.vcp
              _obj['x'] = v.date
              _obj['y'] = v.vcp
              vcp.push(  _obj  )
              return v
            } )
            var data = []
            var o = {}, _o = {}
            o.category = "score"
            o.value = score
            _o.category = "vcp"
            _o.value = vcp
            data.push( o )
            data.push( _o )

            this.setState( {
              chartData : data
            })
          }
        )
      } else {
        this.getIndex()
      }
      
    }
    this.setState( obj )
  }

  getIndex(){
    service.getIndexApi().then(
      (res) => {
        for (var i in res) {
          res[i].value = res[i].value.map( (v,k)=>{
            v.x = v.date
            v.y = v.index
            return v
          } )
        }
        this.setState( {
          chartData : res
        })
      }
    )
  }

  searchSym(symbol, isDisplay) {
    if( symbol.length <= 4) {
      symbol = (([ ...Array( 4-symbol.length )].map( (e, i)=>{ return "0" }  ))).join("") +symbol+".HK"
    }
    //symbol = symbol + ".HK"
    var data = JSON.parse( JSON.stringify( this.state.original ) )
    for (var i in data) {
      if( data[i].symbol === symbol ) {
        var obj = data[i]
        for (var j in this.state.rank ) {
          if( this.state.rank[j].category === obj.category ) {
            if( isDisplay) {
              this.display( this.state.rank[j] )
            }
            this.updateValue({
              selectedCategory : this.state.rank[j],
              selectedSymbol : symbol,
            })
            break
          }
        }
        break
      }
    }
  }

  refresh() {
    this.getIndexRank()
  }

  save() {
    try {
      // Validate data
      const { data } = this.state;
      if (!data || !Array.isArray(data) || data.length === 0) {
        console.error('No valid data to export');
        return;
      }

      // Clean and format data (optional, to handle specific fields)
      const formattedData = data.map(item => ({
        ...item,
        marketcap: Number(item.marketcap).toFixed(2), // Format numbers to 2 decimal places
        score: Number(item.score).toFixed(2),
        vcp: Number(item.vcp).toFixed(2),
        near_50d_high: item.near_50d_high ? 'Yes' : 'No', // Convert booleans to strings
        near_50d_low: item.near_50d_low ? 'Yes' : 'No',
        near_100d_high: item.near_100d_high ? 'Yes' : 'No',
        near_100d_low: item.near_100d_low ? 'Yes' : 'No',
        near_150d_high: item.near_150d_high ? 'Yes' : 'No',
        near_150d_low: item.near_150d_low ? 'Yes' : 'No',
        near_200d_high: item.near_200d_high ? 'Yes' : 'No',
        near_200d_low: item.near_200d_low ? 'Yes' : 'No',
      }));

      // Create worksheet from formatted data
      const worksheet = XLSX.utils.json_to_sheet(formattedData);

      // Optional: Set column widths for better readability
      worksheet['!cols'] = [
        { wch: 40 }, // category
        { wch: 12 }, // date
        { wch: 15 }, // iname
        { wch: 12 }, // marketcap
        { wch: 12 }, // near_50d_high
        { wch: 12 }, // near_50d_low
        { wch: 12 }, // near_100d_high
        { wch: 12 }, // near_100d_low
        { wch: 12 }, // near_150d_high
        { wch: 12 }, // near_150d_low
        { wch: 12 }, // near_200d_high
        { wch: 12 }, // near_200d_low
        { wch: 12 }, // score
        { wch: 10 }, // sname
        { wch: 10 }, // symbol
        { wch: 12 }, // vcp
      ];

      // Create workbook and append worksheet
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

      // Generate filename with YYYYMMDD format
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
      const day = String(date.getDate()).padStart(2, '0');
      const yyyymmdd = `${year}${month}${day}`;

      // Write the Excel file
      XLSX.writeFile(workbook, `export_${yyyymmdd}.xlsx`);
    } catch (error) {
      console.error('Error exporting to Excel:', error);
    }
  }

  render() {
    return(
      <div className={["App"].join(' ')} >
        <div className={["Left"].join(' ')} >

          <div className='Left-H'>
            <Button className={["RefreshBtn"].join(" ")} onClick={ (e)=>{  this.refresh() }} > Refresh </Button>
            <Button className={["SaveBtn"].join(" ")} onClick={ (e)=>{  this.save() }} > Save </Button>
          </div>
          

          <InputGroup className={["mb-3", "IHolder"].join(" ")} >
            <InputGroup.Prepend>
              <InputGroup.Text>Date</InputGroup.Text>
            </InputGroup.Prepend>
            <FormControl
              className={["Input"].join(" ")}
              placeholder="YYYY-MM-DD"
              value={ this.state.date }
              onChange={ 
                (e) => {
                  this.setState( {
                    date : e.target.value
                  } )
                }
              }
            />
            <InputGroup.Append>
              <Button className={["Btn"].join(" ")} variant="outline-secondary" onClick={
                (e) => {
                  this.getIndexRank( this.state.date )
                }
              }>Search</Button>
            </InputGroup.Append>
          </InputGroup>
          
          <InputGroup className={["mb-3", "IHolder"].join(" ")} >
            <InputGroup.Prepend>
              <InputGroup.Text>Symbol</InputGroup.Text>
            </InputGroup.Prepend>
            <FormControl
              className={["Input"].join(" ")}
              placeholder="XXXX"
              value={ this.state.searchSymbol }
              onChange={ 
                (e) => {
                  this.setState( {
                    searchSymbol : e.target.value
                  } )
                }
              }
            />
            <InputGroup.Append>
              <Button className={["Btn"].join(" ")} variant="outline-secondary" onClick={
                (e) => {
                  this.searchSym( this.state.searchSymbol )
                }
              }>Search</Button>
            </InputGroup.Append>
          </InputGroup>
          
          { 
            btn_gp.map( (v,k) => {
              return (          
                <InputGroup className={["mb-3", "IHolder"].join(" ")} key={k}>
                  <InputGroup.Prepend>
                    <InputGroup.Text>{  v.display  }</InputGroup.Text>
                    <Button className={["Btn"].join(" ")} 
                        onClick={ (e)=> {
                          var obj = {}
                          obj[  v.key + '_type'] = !this.state[  v.key + '_type']
                          this.setState( obj )
                    }}> {  this.state[  v.key + '_type']?"<":">=" } </Button>
                  </InputGroup.Prepend>
                  <FormControl
                    className={["Input"].join(" ")}
                    placeholder="0"
                    value={ this.state[v.key] }
                    onChange={ 
                      (e) => {
                        var obj = {}
                        obj[v.key] = e.target.value

                        var searchTypes = this.state.searchTypes
                        try {
                          var mc = e.target.value
                            mc = parseFloat(mc, 10)
                            if( mc === null) {
                              delete searchTypes[v.key]
                            } else {
                              searchTypes[v.key] = mc
                            }
                        } catch(e) {
                          
                        }
                        obj.searchTypes = searchTypes

                        this.setState( obj )
                      }
                    }
                  />
                  {
                    /*<InputGroup.Append>
                      <Button className={["Btn"].join(" ")} variant="outline-secondary" onClick={
                        (e) => {
                          //this.search( this.state[v.key] , v.key )
                          this.search()
                        }
                      }>Search</Button>
                    </InputGroup.Append>*/
                  }
                </InputGroup>
              )
            } )
          }
          <Button className={["GBtn"].join(" ")} onClick={ (e)=>{this.search()}} > Search </Button>
          
          <div className={ ['Group'].join(" ") }>

            { btn2.map( (v, k) => {
                return(
                  <Button 
                    style={
                      {
                        "marginLeft" : ((k % 2)===1)?"1px":"0.5rem",
                        "marginRight" : ((k % 2)===0)?"1px":"0.5rem",
                        //"backgroundColor" : ((k % 2)===1)?"#CE2929":"#39C27F",
                        //"opacity" : 1/(1+Math.floor((k)/2)) 
                      }
                    }
                    className={["GHLBtn" , 
                      (this.state[v.key]?"selected":""),
                      ( v.key === "near_50d_high"?"High50":""),
                      ( v.key === "near_100d_high"?"High100":""),
                      ( v.key === "near_150d_high"?"High150":""),
                      ( v.key === "near_200d_high"?"High200":""),
                      ( v.key === "near_50d_low"?"Low50":""),
                      ( v.key === "near_100d_low"?"Low100":""),
                      ( v.key === "near_150d_low"?"Low150":""),
                      ( v.key === "near_200d_low"?"Low200":"")
                    ].join(" ")} variant="outline-secondary" key={k} onClick={
                    (e) => {
                      var BOOL = true
                      var obj = {}
                      if( this.state[v.key] === true ) {
                        BOOL = null
                      }

                      var searchTypes = this.state.searchTypes
                      if( v.key in searchTypes  ) {
                        delete searchTypes[v.key]
                      } else {
                        searchTypes[v.key] = true
                      }
                      obj.searchTypes = searchTypes
                      obj[v.key] = BOOL
                      this.setState(obj)
                      
                      var _this = this
                      setTimeout( (e) => {
                        _this.search(  )
                      }, 300 )
                      //this.search( BOOL, v.key, true )
                      
                      
                      
                      
                    }
                  }>{ v.display }</Button>
                )
              })
            }

          </div>

          <Button 
              className={["RBtn"].join(" ")}
              onClick={
                (e)=>{
                  this.setState( {
                    data : this.state.original,
                    marketcap : "0",
                    vcp : "0",
                    score : "0",
                    selectedSymbol : null,
                    searchSym : "",
                    searchTypes : {},
                    near_200d_high : null,
                    near_200d_low : null,
                    near_150d_high : null,
                    near_150d_low : null,
                    near_100d_high : null,
                    near_100d_low : null,
                    near_50d_high : null,
                    near_50d_low : null,
                    displayRank : JSON.parse( JSON.stringify(this.state.rank) )
                  } )
                  var _this = this
                  setTimeout( (e)=>{
                    _this.display( _this.state.selectedCategory )
                  }, 500 )
                }
              }
          >{"Reset (CT:" + this.state.data.length + ")"}</Button>

          <div className={["Row", "title" ].join(' ')}  > 
            <div className={["Box"].join(' ')} > {'Rank'} </div> 
            <div className={["Box"].join(' ')} > { 'Category' } </div>
            <div className={["Box"].join(' ')} > { 'Chg(5)' } </div>
            <div className={["Box"].join(' ')} > { 'Chg' } </div>
          </div>
          {
            this.state.displayRank.map( (v,k)  => {
              return(
                <div 
                  onClick={
                    (e)=>{
                      this.display( v )
                    }
                  }
                  className={["Row", ((v.category==="HSI")?"hsi":((this.state.selectedCategory.category===v.category)?"selected":"")) ].join(' ')} key={k} > 
                  <div className={["Box"].join(' ')} > { k+1 } </div> 
                  <div className={["Box"].join(' ')} >
                    {
                      service.match[v.category]
                    }
                  </div>
                  <div className={["Box", (v.ema > 0)?"green":((v.ema < 0)?"red":"") ].join(' ')} >
                    {
                      Math.round( v.ema * 10000 )/100 + "%"
                    }
                  </div>
                  <div className={["Box", (v.change > 0)?"green":((v.change < 0)?"red":"") ].join(' ')} >
                    {
                      Math.round( v.change * 10000 )/100 + "%"
                    }
                  </div>
                </div>
              )
            })
          }
        </div>

        <div className={["Right"].join(' ')}>
          <div className={["Top"].join(' ')}>
            <Chart {...this.props} data={this.state.chartData} selectedCategory={this.state.selectedCategory} updateValue={this.updateValue} rank={this.state.rank} selectedSymbol={this.state.selectedSymbol} />
          </div>
          <div className={["Bottom"].join(' ')}>
            {
              this.state.displayData.map(
                (v,k) => {
                  return(
                    <div className={["Docker"].join(' ')} key={k}>
                      <div className={["Title"].join(' ')}>
                        { (k+1) + ". "  + v.key + "[" +  v.value.length + "]" }
                      </div>
                      {
                        v.value.map( (v1, k1) => {
                          return(
                            <Holder {...this.props} obj={v1} key={k1} index={k1} updateValue={ this.updateValue } selectedSymbol={this.state.selectedSymbol} />
                          )
                        } )
                      }
                    </div>
                  )
                }
              )
            }
          </div>
        </div>
      </div>
    )
  }
}

export default App;

